<template>
    <transition name="fade" mode="out-in">
        <section 
            class="padding-vertical-content  mb-3 mb-lg-4" 
            v-if="mostrar"
            key="preguntaParcelas"
            id="preguntaParcelas"
        >
            <div class="container">
                <div class="row">
                    <b-col cols="12">
                        <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.titulo_pregunta') }}</h2>
                        <div class="subtitle h3 light mb-3">
                            {{ $t('nuevo_abono.descripcion_pregunta_parcela') }}
                        </div>
                    </b-col>
                    <b-col cols="12">
                        <b-row class="mt-4">
                            <b-col cols="12" md="auto">
                                <button 
                                    :class="!esMovil ? 'button large-button' : 'button'"
                                    @click="comprarParcelas"
                                    :disabled="loading || botonesDeshabilitados"
                                >
                                    {{ $t('nuevo_abono.si_quiero') }}
                                </button>

                                <button 
                                    :class="!esMovil ? 'button large-button ml-2' : 'button ml-2'"
                                    @click="continuarSinParcelas"
                                    :disabled="loading || botonesDeshabilitados"
                                >
                                    {{ $t('nuevo_abono.no_continuar') }}
                                </button>

                                <button
                                    id="atras"
                                    :class="!esMovil ? 'button large-button ml-2' : 'button  mt-2'"
                                    @click="volver"
                                    :disabled="loading || botonesDeshabilitados"
                                >
                                    {{ $t('nuevo_abono.atras') }}
                                </button>
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
    export default {
        name: 'PreguntarParcelasComponent',
        props: {
            mostrar: {
                type: Boolean,
                default: false
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            botonesDeshabilitados: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            comprarParcelas() {
                this.$emit('quiereParcelas', true);
            },
            
            continuarSinParcelas() {
                this.$emit('quiereParcelas', false);
            },
            
            volver() {
                this.$emit('volver');
            }
        }
    }
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

@media (min-width: 397px) {
    #atras {
        margin-top: 0 !important;
        margin-left: 0.5rem !important;
    }
}
</style>